import { useTranslation } from "next-i18next";
import { BootstrapInput } from "../UI/BootstrapInput";
import { ErrorTips } from "../UI/ErrorTips";

export const ContractInfo = ({
  formValues,
  formErrors,
  shouldValidateDiscordId = false,
  onFieldChange,
}) => {
  const { t } = useTranslation("mall");

  return (
    <div>
      <div className="text-[22px] leading-[32px] font-bold font-DIN_Alternate mb-[24px]">
        {t("orderContract")}
      </div>

      <div className="mb-[24px]">
        <div className="font-bold mt-[26px] mb-[16px] flex items-center">
          <div>
            {t("orderEmail")}
            <span className="text-[#FF2800] ml-[4px]">*</span>
          </div>

          {formErrors?.email && (
            <ErrorTips className="ml-[8px]">{formErrors?.email}</ErrorTips>
          )}
        </div>
        <div>
          <BootstrapInput
            className="w-full"
            placeholder={t("orderEmailPlaceholder")}
            value={formValues?.email}
            onChange={(event) => {
              onFieldChange("email", event.target.value);
            }}
          />
        </div>
      </div>

      <div className="mb-[24px]">
        <div className="font-bold mt-[26px] mb-[16px] flex items-center">
          <div>
            Discord ID
            {shouldValidateDiscordId && (
              <span className="text-[#FF2800] ml-[4px]">*</span>
            )}
          </div>

          {shouldValidateDiscordId && formErrors?.discordId && (
            <ErrorTips className="ml-[8px]">{formErrors?.discordId}</ErrorTips>
          )}
        </div>

        <div>
          <BootstrapInput
            className="w-full"
            placeholder={t("wlDCPlaceholder")}
            value={formValues?.discordId}
            onChange={(event) => {
              onFieldChange("discordId", event.target.value);
            }}
          />
        </div>
      </div>

      <div className="mb-[24px]">
        <div className="font-bold mt-[26px] mb-[16px] flex items-center">
          <div>{t("orderTwitterHandle")}</div>
        </div>
        <div>
          <BootstrapInput
            className="w-full"
            placeholder={t("orderTwitterHandlePlaceholder")}
            value={formValues?.twitterHandle}
            onChange={(event) => {
              onFieldChange("twitterHandle", event.target.value);
            }}
          />
        </div>
      </div>

      <div className="mb-[24px]">
        <div className="font-bold mt-[26px] mb-[16px] flex items-center">
          <div>{t("orderPhone")}</div>
        </div>
        <div>
          <BootstrapInput
            className="w-full"
            placeholder={t("orderPhonePlaceholder")}
            value={formValues?.phone}
            onChange={(event) => {
              onFieldChange("phone", event.target.value);
            }}
          />
        </div>
      </div>
    </div>
  );
};
